var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2253 17.0997C21.0253 17.283 20.792 17.3789 20.5253 17.3872C20.2586 17.3955 20.0253 17.2997 19.8253 17.0997L11.9503 9.2247L4.0753 17.0997C3.89197 17.283 3.6628 17.3789 3.3878 17.3872C3.1128 17.3955 2.8753 17.2997 2.6753 17.0997C2.4753 16.9164 2.37114 16.6872 2.3628 16.4122C2.35447 16.1372 2.4503 15.8997 2.6503 15.6997L11.4253 6.9247C11.5086 6.84136 11.592 6.78303 11.6753 6.7497C11.7586 6.71636 11.8503 6.6997 11.9503 6.6997C12.0503 6.6997 12.142 6.71636 12.2253 6.7497C12.3086 6.78303 12.392 6.84136 12.4753 6.9247L21.2503 15.6997C21.4336 15.883 21.5253 16.1122 21.5253 16.3872C21.5253 16.6622 21.4253 16.8997 21.2253 17.0997Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.8a853011eb9b435beed18511cc0354f1.svg";
export { ForwardRef as ReactComponent };